import { catchError, map } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { of, OperatorFunction } from 'rxjs';

export function mapResponseBody<T>(): OperatorFunction<HttpResponse<T>, T> {
  return map((response: HttpResponse<T>) => response.body as T);
}

export function catchAndMapError<T>(
  fallback: unknown = null
): OperatorFunction<T, T | null> {
  return catchError(() => of(fallback as T | null));
}
